import React, { Component } from 'react';
import { withStyles } from '../../styles';
import PropTypes from 'prop-types';
import Radium from 'radium';
import styles from './DoubleLayout_styles';

const propTypes = {
    styles: PropTypes.object,
    renderLeft: PropTypes.node,
    renderRight: PropTypes.node,
};

class DoubleLayout extends Component {
    state = {};
    render() {
        const { styles, renderLeft, renderRight } = this.props;
        return renderRight ? (
            <div style={styles.mainLayout}>
                <div style={styles.leftLayout}>{renderLeft}</div>
                <div style={styles.rightLayout}>{renderRight}</div>
            </div>
        ) : (
            <div style={styles.mainLayout}>{renderLeft}</div>
        );
    }
}

DoubleLayout.propTypes = propTypes;

export default withStyles(styles)(Radium(DoubleLayout));
